import { AppData, Lightning, Log } from '@lightningjs/sdk'
import { Helper } from '../lib/helper';
import { Platform } from '../platforms/platform';
import { AppSetup } from '../lib/app-setup';

export interface CCItemTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

const controlsTextColor = 0xffffffff;
const controlsTextColorFocus = 0xffffffff;
const controlsTextColorSelected = 0xffff0000;
const controlsBGColorSelected = 0xffffffff;
const controlsBGColorFocus = 0xffff0000;
const controlsBGColor = 0xff000000;


export default class CCItem
  extends Lightning.Component<CCItemTemplateSpec>
  implements Lightning.Component<CCItemTemplateSpec>
{
  selected = false
  content = ''
  itemIndex= 0
  private _focusAnimation: Lightning.types.Animation | undefined = undefined
  static override _template(): Lightning.Component.Template<CCItemTemplateSpec> {
    return {
      w: (w: any) => w,
      h: (h: any) => h,
      rect: true,
      color: controlsBGColor,
      Label: {
        x: 20,
        y: (h: any) => h / 2 + 5,
        mountY: 0.5,
        text: {
          text: "",
          fontSize: 30,
          // fontFace: Helper.getFontFamily('Regular'),
          letterSpacing: 0.82,
        },
      }
    }
  }

  override _handleEnter() {
    this.fireAncestors('$ItemSelected', this.itemIndex)
    return true
  }

  override _init() {
    if (this._focusAnimation) {
      this._focusAnimation.stop()
    }
  }

  _updateSelectedStatus() {
    const bgColor = this.selected ? controlsBGColorSelected : controlsBGColor
    const textColor = this.selected ? controlsTextColorSelected: controlsTextColor
    this._focusAnimation = this.animation({
      duration: 0.3,
      actions: [
        // { p: 'scale', v: { 0: 1, 1: 1.1 } },
        { p: 'color', v: { 0: bgColor, 1: controlsBGColorFocus } },
        { t: 'Label' , p: 'text.textColor', v: { 0: textColor, 1: controlsTextColorFocus } }
      ],
    });
    this._focusAnimation.start()
    this._focusAnimation.stop()
  }

  override _focus() {
    if (this._focusAnimation) {
      this._focusAnimation.start()
    }
  }        

  override _unfocus() {
    if (this._focusAnimation) {
      this._focusAnimation.stop()
    }
  }

  set itemSelected(itemSelected: any) {
    this.selected = itemSelected || false
    Log.info('CCItem itemSelected: ', this.selected)
    this._updateSelectedStatus()
  }
  set item(itemInfo: any) {
    Log.info('CCItem setItem: ', itemInfo.name)
    this.tag('Label').text.text = itemInfo.name
  }

  // _handleHover(target) {
  //  // console.log('OptionsMenuItem _handleHover : ', target, this.itemIndex)
  //   this.fireAncestors('$onIndexHover', {index: this.itemIndex})
  // }
}
